import React, { useState } from "react";
import { X, UserCheck, Loader2 } from "lucide-react";
import { showToast } from "../../components/common/notification/Notification";
import { addContact } from "./networkApi";

const AddContactModal = ({ show, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_address: "",
    address: "",
    area_name: "",
    zip_code: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name?.trim()) {
      showToast("First Name is required", { type: "error" });
      return;
    }

    if (!formData.mobile_number?.trim() || formData.mobile_number.length < 10) {
      showToast("A valid 10-digit mobile number is required", { type: "error" });
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await addContact(formData);

      if (res?.statusType === "SUCCESS" || res?.status === "SUCCESS" || res?.contact) {
        showToast("Contact added successfully!", { type: "success" });
        onSuccess?.();
        onClose?.();
      } else {
        showToast(res?.text || res?.message || "Failed to add contact", { type: "error" });
      }
    } catch (err) {
      console.error("Add contact error:", err);
      showToast(err?.response?.data?.text || "An error occurred while adding contact", {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="net-modal-overlay" onClick={onClose}>
      <div className="net-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="net-modal-form">
          <div className="net-modal__header">
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#f0fdf4",
                  color: "#16a34a",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <UserCheck size={18} />
              </div>
              <div>
                <h3 className="net-modal__title">Add Friend / Customer</h3>
                <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
                  Add personal contacts and clients to your address book
                </p>
              </div>
            </div>
            <button type="button" className="net-drawer__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <div className="net-modal__body">
            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  className="net-form-input"
                  placeholder="e.g. Jane"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="net-form-input"
                  placeholder="e.g. Smith"
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Mobile Number *</label>
                <input
                  type="tel"
                  name="mobile_number"
                  className="net-form-input"
                  placeholder="10-digit number"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
                  maxLength={10}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Email Address</label>
                <input
                  type="email"
                  name="email_address"
                  className="net-form-input"
                  placeholder="jane@example.com"
                  value={formData.email_address}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Area / Locality</label>
                <input
                  type="text"
                  name="area_name"
                  className="net-form-input"
                  placeholder="e.g. Bandra"
                  value={formData.area_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Zip / Pin Code</label>
                <input
                  type="text"
                  name="zip_code"
                  className="net-form-input"
                  placeholder="e.g. 400050"
                  value={formData.zip_code}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-group">
              <label className="net-form-label">Address</label>
              <input
                type="text"
                name="address"
                className="net-form-input"
                placeholder="Building / Flat / Street"
                value={formData.address}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="net-modal__footer">
            <button type="button" className="net-btn net-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="net-btn net-btn--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="net-spin" /> Adding...
                </>
              ) : (
                "Save Contact"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContactModal;
